(function () {
  const KEY = 'specr_tire_compare';
  const MAX = 4;

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.slice(0, MAX) : [];
    } catch {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent('specr:tire-compare-changed'));
  }

  window.SpecrTireCompare = {
    add(item) {
      const list = read().filter(
        (x) => x.variantId !== item.variantId && (!item.handle || x.handle !== item.handle)
      );
      list.push(item);
      write(list);
      return list;
    },
    replace(items) {
      write(Array.isArray(items) ? items : []);
      return read();
    },
    remove(variantId) {
      write(read().filter((x) => x.variantId !== variantId));
    },
    /** Switch size/variant for a product already in the compare list (matched by handle). */
    selectVariant(handle, variantId) {
      if (!handle || !variantId) return read();
      const list = read();
      const idx = list.findIndex((x) => x.handle === handle);
      if (idx < 0) return list;
      const item = list[idx];
      const variants = item.variants || [];
      const picked = variants.find((v) => String(v.variantId) === String(variantId));
      if (!picked) return list;
      const priceNum = picked.price != null && !isNaN(picked.price) ? picked.price : item.priceNum;
      list[idx] = Object.assign({}, item, {
        variantId: String(picked.variantId),
        size: picked.tireSize || item.size,
        price: priceNum != null ? "$" + Number(priceNum).toFixed(2) : item.price,
        priceNum: priceNum,
        season: picked.season || item.season || "",
        speedLoad: picked.speedLoad || item.speedLoad || "",
        utqg: picked.utqg || item.utqg || "",
        studdable: picked.studdable || item.studdable || "",
        runFlat: picked.runFlat || item.runFlat || "",
        url:
          (item.url || "").split("?")[0] +
          "?variant=" +
          encodeURIComponent(String(picked.variantId)),
      });
      write(list);
      return list;
    },
    /** Attach variant list from compare catalog (by product handle). */
    enrichVariants(handle, variants) {
      if (!handle || !variants || !variants.length) return read();
      const list = read();
      const idx = list.findIndex((x) => x.handle === handle);
      if (idx < 0) return list;
      list[idx] = Object.assign({}, list[idx], { variants: variants });
      write(list);
      return list;
    },
    clear() {
      write([]);
    },
    list: read,
    max: MAX,
  };
})();
